import {
  Product3DAssetBounds,
  Product3DDimensions,
} from "../products/product3DTypes";

export type UserModel3DLibraryItem = {
  id: string;
  name: string;
  displayTitle: string;
  displayDescription?: string | null;
  uploaderId: string;
  uploaderName: string;
  originalFilename: string;
  status: "processing" | "ready" | "failed" | string;
  source: "upload" | "image" | string;
  stage?:
    | "queued"
    | "submitting"
    | "generating"
    | "downloading"
    | "optimizing"
    | string
    | null;
  progress?: number | null;
  errorMessage?: string | null;
  optimizedUrl?: string | null;
  thumbnailUrl?: string | null;
  sourceImageUrl?: string | null;
  footprintSvg?: string | null;
  architectureSymbolKey?: string | null;
  dimensions?: Product3DDimensions | null;
  bounds?: Product3DAssetBounds | null;
  /** Optional retail price (incl. VAT), mirroring Personal Library. */
  price?: number | null;
  currency?: string | null;
  /** Optional product / store URL. */
  url?: string | null;
  brand?: string | null;
  fileBytes?: number | null;
  triangleCount?: number | null;
  vertexCount?: number | null;
  textureMaxSize?: number | null;
  sha256?: string | null;
  pipelineVersion?: string | null;
  shareWithCommunity: boolean;
  isCommunityListed: boolean;
  communityListingState: string;
  firstSharedAt?: string | null;
  ownerArchivedAt?: string | null;
  moderationState: string;
  createdAt?: string | null;
  updatedAt?: string | null;
};

export const getUserModel3DTitle = (
  model: Pick<UserModel3DLibraryItem, "name" | "displayTitle">,
): string => model.name?.trim() || model.displayTitle?.trim() || "3D object";

export const getUserModel3DUploaderLabel = (
  model: Pick<UserModel3DLibraryItem, "uploaderName">,
): string => model.uploaderName.trim() || "BONI user";
